// pages/Stands.js
import React, { useEffect } from 'react';
import Carousel from '../components/Carousel';

function StandsENG() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="stands-page" >

    <div style={{
      padding: '80px 0 40px',
      textAlign: 'center',
      backgroundImage: 'url(/images/cover.jpg)',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      position: 'relative',
      width: '100%',
      marginLeft: 'calc(-50vw + 50%)',
      minHeight: '400px'
    }}>
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        zIndex: 1
      }}></div>
      <div className="container" style={{ position: 'relative', zIndex: 2, padding: '0 20px' }}>

      <style jsx>{`
        @media (max-width: 768px) {
          .stands-page > div:first-child {
            padding: 60px 0 30px !important;
            min-height: 300px !important;
          }
          .stands-page h1 {
            font-size: 2.5rem !important;
          }
          .stands-page h3 {
            font-size: 1.4rem !important;
          }
        }
      `}</style>
      <img
        src="/images/Asset7.png"
        alt="Stands Icon"
        style={{
          width: '80px',
          height: '80px',
          objectFit: 'contain'
        }}
      />
      <h1 style={{
        fontSize: '3.5rem',
        marginBottom: '20px',
        background: 'linear-gradient(135deg, var(--primary-orange), var(--secondary-orange))',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        backgroundClip: 'text',
        direction: 'ltr'
      }}>
      Interactive exhibitions and booths
      </h1>

      <h3 style={{
        fontSize: '2rem',
        marginBottom: '20px',
        fontWeight: '600',
        lineHeight: '1.6',
        direction: 'ltr'
      }}>
        "SPEAK OUT AGAINST GENDER-BASED VIOLENCE"

      </h3>
      </div>
    </div>

      {/* Context Section */}
      <div style={{ background: 'var(--secondary-black)', padding: '60px 0', direction: 'ltr' }}>
        <div className="container">

          {/* Context Description */}
          <div style={{ marginBottom: '50px', direction: 'ltr' }}>
            <h3 style={{
              fontSize: '2.3rem',
              marginBottom: '35px',
              textAlign: 'center',
              color: 'var(--white)',
              direction: 'ltr'
            }}>
              Context
            </h3>

            <div style={{
              background: 'linear-gradient(135deg, rgba(255, 107, 53, 0.1), rgba(255, 133, 85, 0.05))',
              padding: '35px',
              borderRadius: '15px',
              borderRight: '5px solid var(--primary-orange)',
              marginBottom: '40px',
              textAlign:'center'
            }}>
            <p style={{
        fontSize: '1.15rem',
        lineHeight: '2',
        color: 'var(--text-light)',
        justifySelf: 'center',
        marginBottom: '20px',

      }}>
        As part of its national campaign "Speak out against gender-based violence" to end digital violence targeting women and girls, the{' '}
        <strong style={{ color: 'var(--primary-orange)' }}>
          National Human Rights Council
        </strong>{' '}
         organizes interactive exhibitions and booths in three major public squares in Rabat. The campaign is themed <strong style={{ color: 'var(--primary-orange)' }}>"A silent digital pandemic threatening society"</strong> and runs from November 25 to December 10, 2025.
      </p>


      <p style={{
        fontSize: '1.2rem',
        lineHeight: '2',
        color: 'var(--text-light)',
        direction: 'ltr'
      }}>
        These open spaces offer visitors an engaging experience that combines awareness and interaction, shedding light on one of the most dangerous forms of violence in the contemporary world: digital violence.
      </p>

            </div>
          </div>

          {/* Objectives Section */}
          <div style={{ marginBottom: '50px', direction: 'ltr' }}>
            <h3 style={{
              fontSize: '2.3rem',
              marginBottom: '35px',
              textAlign: 'center',
              color: 'var(--white)',
              direction: 'ltr'
            }}>
              Objectives
            </h3>

            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
              gap: '25px',
                textAlign:'left'
            }}>
              {[
                {
                  icon: '🛡️',
                  title: 'Foster a culture of rights',
                  desc: 'Promote a culture of women\'s and girls\' rights in the digital space'
                },
                {
                  icon: '🔒',
                  title: 'Promote digital safety',
                  desc: 'Raise awareness about digital safety and responsible tehcnology use to prevent online violence'
                },
                {
                  icon: '📚',
                  title: 'Raise awareness on violence',
                  desc: 'Highlight the various forms of digital violence and their psychological, social, and legal impacts'
                },
                {
                  icon: '📢',
                  title: 'Promote reporting',
                  desc: 'Encourage women and girls to speak up, report online abuse, and break the silence'
                }
              ].map((item, index) => (
                <div key={index} style={{
                  background: 'var(--primary-black)',
                  padding: '25px',
                  borderRadius: '15px',
                  border: '1px solid rgba(255, 107, 53, 0.3)',
                  transition: 'all 0.3s ease',
                  direction: 'ltr'
                }}>
                  <div style={{ fontSize: '2.5rem', marginBottom: '15px' }}>{item.icon}</div>
                  <h4 style={{ fontSize: '1.4rem', marginBottom: '12px', color: 'var(--primary-orange)' }}>
                    {item.title}
                  </h4>
                  <p style={{ fontSize: '1.05rem', lineHeight: '1.7', color: 'var(--text-light)' }}>
                    {item.desc}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* Locations and Dates */}
          <div style={{ marginBottom: '50px', direction: 'ltr' }}>
            <h3 style={{
              fontSize: '2.3rem',
              marginBottom: '35px',
              textAlign: 'center',
              color: 'var(--white)',
              direction: 'ltr'
            }}>
              Come visit our campaign booths
            </h3>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '25px', textAlign:'left' }}>
              {[
                {
                  dates: 'November 25–29, 2025',
                  location: 'Mahaj Riad, Hay Riad, Rabat',
                  icon: '📍'
                },
                {
                  dates: 'November 30 – December 4, 2025',
                  location: 'In front of the Parliament',
                  icon: '🏛️'
                },
                {
                  dates: 'December 5–9, 2025',
                  location: 'Agdal Train Station, Rabat',
                  icon: '🚉'
                }
              ].map((item, index) => (
                <div key={index} style={{
                  background: 'var(--primary-black)',
                  padding: '30px',
                  borderRadius: '15px',
                  border: '2px solid var(--primary-orange)',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '25px',
                  transition: 'all 0.3s ease',
                  direction: 'ltr'
                }}>
                  <div style={{
                    fontSize: '3rem',
                    minWidth: '60px',
                    textAlign: 'center'
                  }}>
                    {item.icon}
                  </div>
                  <div style={{ flex: 1 }}>
                    <div style={{
                      background: 'linear-gradient(135deg, var(--primary-orange), var(--secondary-orange))',
                      padding: '10px 20px',
                      borderRadius: '10px',
                      fontWeight: '700',
                      fontSize: '1.2rem',
                      marginBottom: '15px',
                      display: 'inline-block'
                    }}>
                      {item.dates}
                    </div>
                    <h4 style={{
                      fontSize: '1.5rem',
                      color: 'var(--white)',
                      lineHeight: '1.6'
                    }}>
                      {item.location}
                    </h4>
                  </div>
                </div>
              ))}
            </div>
          </div>

    <div className="section-separator"></div>

          <div style={{ textAlign: 'center', marginTop: '50px', direction: 'ltr' }}>
            <h3 style={{
              fontSize: '2.5rem',
              marginBottom: '25px',
              color: 'var(--white)',
              direction: 'ltr'
            }}>
            Join us in this national campaign to end digital violence against women and girls
            </h3>

            <p style={{
              fontSize: '1.2rem',
              marginTop: '30px',
              color: 'var(--text-light)',
              fontStyle: 'italic',
              direction: 'ltr'
            }}>
              Together we express our rights | Together we build the future
            </p>
          </div>
        </div>
      </div>

  <Carousel />
    </div>
  );
}

export default StandsENG;
